import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  formField: {
    position: "relative",
    width: "100%",
    marginBottom: 24,
  },
  formField_error: {
    margin: "8px 0 0",
    display: "block",
    width: "100%",
    color: "var(--error-main)",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.2,
    textTransform: "none",
    textAlign: "left",
    transition: "all .2s ease",
  },
  inputError: {
    '& label': {
      color: "#FF3333!important",
    },
    '& fieldset': {
      borderColor: "#FF3333!important",
      '& legend': {
        color: "#FF3333",
      },
    },
  },
  inputErrorDef: {
    '& fieldset': {
      '& legend': {
        color: "#FF3333",
      },
    },
  },
  input: {},
}));
